import FormProvider, { RHFTextField } from '@Components/hook-form';
import { useTestsForm } from '@Forms/tests/TestsFormContext';
import { Box, Button, Stack } from '@mui/material';
import { useTestProviderMutation } from '@Src/generated.graphql';
import { BaseSyntheticEvent, useCallback } from 'react';
import { useFormState } from 'react-hook-form';
import { TestsResult } from './TestsResult';

export const TestsForm = () => {
  const [testProvider, { data: testProviderData }] = useTestProviderMutation();
  const methods = useTestsForm();
  const { control, handleSubmit } = useTestsForm();
  const { isDirty, errors } = useFormState({ control });

  const handleSubmitTests = useCallback(
    (e?: BaseSyntheticEvent) => {
      handleSubmit(async (formData) => {
        try {
          await testProvider({ variables: { testProviderInput: formData } });
        } catch (error) {
          console.error(error);
        }
      })(e);
    },
    [handleSubmit]
  );
  return (
    <Stack direction="column" spacing={2}>
      <FormProvider methods={methods}>
        <Stack direction="row" spacing={2}>
          <Box sx={{ width: '300px' }}>
            <RHFTextField name="url" label="URL" fullWidth />
          </Box>
          <Box sx={{ width: '300px' }}>
            <RHFTextField name="currency" label="Currency" />
          </Box>
          <Box sx={{ width: '300px' }}>
            <RHFTextField name="amount" label="Amount" />
          </Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ width: '100px', paddingX: '20px' }}
            onClick={handleSubmitTests}
            disabled={!isDirty || Object.keys(errors).length > 0}
          >
            Submit
          </Button>
        </Stack>
      </FormProvider>
      <TestsResult
        message={testProviderData?.testProvider?.message || ''}
        errorsCount={testProviderData?.testProvider?.errorsCount || 0}
        data={testProviderData?.testProvider?.data || []}
      />
    </Stack>
  );
};
